module.exports = __webpack_public_path__ + "6001fd20e32d6ee80f3494c3aa91f3f9.MP3";